export default "__VITE_ASSET__Xx$B98Nq__"